const initialData = {
	cloud: false,
	locked: true,
	cueToEdit: null,
	editing: false,
};

export default function rundowReducer(state = initialData, action) {
	switch (action.type) {
		case "RUNDOWN_LOCK":
			return { ...state, locked: action.locked };

		case "CUE_TO_EDIT":
			return { ...state, cueToEdit: action.cue, editing: action.editing };

		default:
			return state;
	}
}
